"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

var _globals = require("../../../globals.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var borderStyleReset = {
  idleBorderColor: 'transparent',
  focusBorderColor: 'transparent',
  hoverBorderColor: 'transparent',
  disabledBorderColor: 'transparent',
  errorBorderColor: 'transparent',
  idleBoxShadow: 'none',
  focusBoxShadow: 'none',
  hoverBoxShadow: 'none',
  disabledBoxShadow: 'none',
  errorBoxShadow: 'none',
  idleOutline: 'none',
  focusOutline: 'none',
  hoverOutline: 'none',
  disabledOutline: 'none',
  errorOutline: 'none',
  idleBorderStyle: 'none',
  hoverBorderStyle: 'none',
  focusBorderStyle: 'none',
  errorBorderStyle: 'none',
  disabledBorderStyle: 'none',
  borderWidth: 0,
  display: 'inline-block'
};

function _default(theme, props, state) {
  var _inputTheme, _inputTheme2;

  var _theme = theme,
      palette = _theme.palette,
      style = props.style;
  theme = _objectSpread({}, theme, {
    labelColor: theme.idleLabelColor,
    borderColor: theme.idleBorderColor,
    borderStyle: theme.idleBorderStyle,
    borderTransform: theme.idleBorderTransform,
    borderWidth: theme.idleBorderWidth,
    borderRadius: theme.idleBorderRadius,
    background: theme.idleBackground,
    boxShadow: theme.idleBoxShadow
  });

  if (state.hover) {
    theme = _objectSpread({}, theme, {
      labelColor: theme.hoverLabelColor,
      borderColor: theme.hoverBorderColor,
      borderStyle: theme.hoverBorderStyle,
      borderTransform: theme.hoverBorderTransform,
      borderWidth: theme.hoverBorderWidth,
      borderRadius: theme.hoverBorderRadius,
      background: theme.hoverBackground,
      boxShadow: theme.hoverBoxShadow
    });
  }

  if (state.focus) {
    theme = _objectSpread({}, theme, {
      labelColor: props.error ? theme.errorLabelColor : theme.focusLabelColor,
      borderColor: theme.focusBorderColor,
      borderStyle: theme.focusBorderStyle,
      borderTransform: theme.focusBorderTransform,
      borderWidth: theme.focusBorderWidth,
      borderRadius: theme.focusBorderRadius,
      background: theme.focusBackground,
      boxShadow: theme.focusBoxShadow
    });
  }

  if (props.error) {
    theme = _objectSpread({}, theme, {
      borderColor: theme.errorBorderColor,
      borderStyle: theme.errorBorderStyle,
      borderTransform: theme.errorBorderTransform,
      borderWidth: theme.errorBorderWidth,
      borderRadius: theme.errorBorderRadius,
      background: theme.errorBackground,
      boxShadow: theme.errorBoxShadow
    });
  }

  if (props.disabled) {
    theme = _objectSpread({}, theme, {
      labelColor: theme.disabledLabelColor,
      borderStyle: theme.disabledBorderStyle,
      borderColor: theme.disabledBorderColor,
      borderTransform: theme.disabledBorderTransform,
      borderWidth: theme.disabledBorderWidth,
      borderRadius: theme.disabledBorderRadius,
      background: theme.disabledBackground,
      boxShadow: theme.disabledBoxShadow
    });
  }

  var inputTheme;

  if (style === null || style === void 0 ? void 0 : style.input) {
    // new style theme
    if (style.input.input) {
      inputTheme = style.input.input[_globals.STATE.IDLE];
    } else {
      inputTheme = style.input;
    }
  } // рамка со всех сторон, классический инпут
  // скрываем нижнюю границу, применяем стиль к инпуту напрямую


  var wrappedBorder = !/none/.test(theme.borderStyle),
      passiveBorderOpacity = wrappedBorder || props.disabled ? 0 : 1,
      activeBorderOpacity = wrappedBorder ? 0 : 1,
      // padding left throws to DropDownSearch. there is no paddingLeft usage here.
  codeWidth = palette.gutter * 12 + (0, _pixelToNumber["default"])(theme.paddingLeft),
      codeTheme = theme.dropDownSearch,
      fontSize = (0, _pixelToNumber["default"])(((_inputTheme = inputTheme) === null || _inputTheme === void 0 ? void 0 : _inputTheme.fontSize) || (codeTheme === null || codeTheme === void 0 ? void 0 : codeTheme.fontSize) || theme.fontSize),
      lineHeight = ((_inputTheme2 = inputTheme) === null || _inputTheme2 === void 0 ? void 0 : _inputTheme2.lineHeight) || (codeTheme === null || codeTheme === void 0 ? void 0 : codeTheme.lineHeight) || theme.lineHeight,
      height = typeof lineHeight === 'string' ? lineHeight : fontSize * lineHeight;
  var fieldBorder = {};

  if (wrappedBorder) {
    fieldBorder = {
      borderStyle: theme.borderStyle,
      borderColor: theme.borderColor,
      borderWidth: theme.borderWidth,
      borderRadius: theme.borderRadius
    };
  }

  return {
    root: {
      display: theme.display,
      width: theme.width,
      minWidth: theme.minWidth
    },
    wrapper: {
      position: 'relative'
    },
    label: {
      color: theme.labelColor,
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      transition: "color ".concat(theme.labelTransitionDuration, " ").concat(theme.labelTransitionFunction),
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      width: '100%',
      overflow: theme.labelOverflow,
      textAlign: 'left',
      paddingTop: '0',
      paddingRight: theme.labelPaddingRight,
      paddingBottom: '0',
      paddingLeft: theme.labelPaddingLeft,
      fontFamily: theme.fontFamily
    },
    input: _objectSpread({
      transition: "border ".concat(palette.transitionDuration, " ease"),
      paddingTop: theme.paddingTop,
      paddingBottom: theme.paddingBottom,
      background: theme.background,
      boxShadow: theme.boxShadow,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'stretch'
    }, fieldBorder),
    divider: {
      margin: "auto ".concat(palette.gutter * 2, "px auto ").concat(palette.gutter, "px"),
      height: height
    },
    border: {
      borderImage: 'none',
      borderStyle: theme.borderStyle,
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      width: '100%',
      position: 'absolute',
      bottom: 0,
      borderColor: theme.idleBorderColor,
      borderWidth: 'medium medium 1px',
      opacity: passiveBorderOpacity
    },
    activeBorder: {
      borderImage: 'none',
      borderStyle: theme.borderStyle,
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: 'ease',
      transitionProperty: 'opacity, transform, border',
      width: '100%',
      position: 'absolute',
      bottom: 0,
      borderWidth: 'medium medium 2px',
      borderColor: theme.borderColor,
      transform: theme.borderTransform,
      opacity: activeBorderOpacity
    },
    code: _objectSpread({}, codeTheme, {}, borderStyleReset, {
      width: codeWidth + 'px',
      paddingLeft: theme.paddingLeft || 0,
      paddingRight: 0,
      listMinWidth: this.root.current && this.root.current.offsetWidth
    }),
    item: {
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    itemImg: {
      marginRight: palette.gutter + 'px',
      width: palette.gutter * 2 + 'px',
      flexShrink: 0
    },
    itemCode: {
      paddingRight: palette.gutter + 'px',
      width: palette.gutter * 6 + 'px',
      flexShrink: 0
    },
    itemName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: "calc(100% - ".concat(palette.gutter * 9 + 'px', ")")
    }
  };
}